import { useQuery } from '@tanstack/react-query';
import { learnerApiJson } from '@/lib/learner-api';
import { useLearnerAuth } from '@/providers/LearnerAuth';

export function usePremiumAccess() {
  const auth = useLearnerAuth();
  const user = useQuery({
    queryKey: ['learner-user'],
    queryFn: () =>
      learnerApiJson<{ subscribed: boolean; subscription_store?: string | null }>(
        auth?.getToken ?? null,
        '/v1/user',
        { auth: true },
      ),
    enabled: Boolean(auth?.isSignedIn),
    staleTime: 30_000,
  });
  return {
    isReady: !auth?.isSignedIn || !user.isLoading,
    isSubscribed: Boolean(user.data?.subscribed),
    store: user.data?.subscription_store ?? null,
    refresh: user.refetch,
  };
}
